<a class="card-dep h-full" (click)="goTo()">
  <div
    class="bg-travel"
    [ngStyle]="{
      'background-image':
        'url(' + (travel | travelImagePipe | imagePipe : 'travel' : 'lg') + ')'
    }"
  >
    <div class="alert-container flex align-items-center gap-2">
      @if( checkDatesForAlert(travel) ){
      <div
        class="card-alert danger"
        pTooltip="In partenza!"
        tooltipPosition="top"
      >
        <img src="/assets/media/icons/dep-time.png" />
      </div>
      } @if( checkForAvailability(travel) ){
      <div
        class="card-alert danger"
        pTooltip="Posti quasi esauriti!"
        tooltipPosition="top"
      >
        <img src="/assets/media/icons/alert.png" />
      </div>
      }
    </div>
    <div class="price">
      <span>
        Da
        {{
          travel.pricing_mode === 1
            ? travel.price_room
            : (cheapestPackagePrice
              | currency : travel.currency : "symbol" : ".0-0")
        }}</span
      >
    </div>
    <div id="scroll-container">
      <div id="scroll-text">
        <span class="white-space-nowrap">
          {{ strippedString }}
        </span>
      </div>
    </div>
  </div>

  <div class="info">
    <h3 class="mt-0">
      {{
        travel.name.length > 27
          ? (travel.name | slice : 0 : 27) + "..."
          : travel.name
      }}
    </h3>
    <div class="flex align-items-center gap-4">
      @for (c of travel.categories| slice: 0:3; track $index) {
      <div class="flex align-items-center gap-3 mb-3">
        <img [src]="c.category.id | travelType" height="24" />
        <small>{{ c.category.name }}</small>
      </div>
      } @if(travel.categories.length > 3){
      <small>...</small>
      }
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <img src="/assets/media/icons/back-in-time.png" />
      <small>{{ dates | daysAndNights }}</small>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <img src="/assets/media/icons/departures.png" />
      <small
        >{{ travel.from_date | date : "dd MMMM yyyy" }} -
        {{ travel.to_date | date : "dd MMMM yyyy" }}</small
      >
    </div>
    @if(travel.undisclosed_members_list === false){
    <div class="flex align-items-center gap-2">
      <small>Partecipanti</small>
      @if(travel.availability?.booked! > 0){
      <p-avatarGroup>
        @for (a of travel.availability?.summary; track $index) {
        <p-avatar
          [image]="a.profile_picture | imagePipe : 'user-w' : 'sm'"
          shape="circle"
          [pTooltip]="a.name"
        ></p-avatar>
        } @if (travel.availability?.more != 0) {
        <p-avatar
          [label]="'+' + travel.availability?.more"
          shape="circle"
          [style]="{ 'background-color': '#3c4e58', color: '#ffffff' }"
        ></p-avatar>
        }
      </p-avatarGroup>
      }@else {
      <small class="grey-text pad-small">Nessun traveler presente.</small>
      }
    </div>
    }@else {
    <div class="flex align-items-center gap-2">
      <small>Partecipanti</small>
      <small class="grey-text pad-small">Lista privata.</small>
    </div>
    }
  </div>
  <!-- <footer>
    <div class="flex align-items-center gap-3">
      <div>
        <p-avatar
          shape="circle"
          [image]="travel.related_user.profile_picture | imagePipe:'user':'sm'"
        ></p-avatar>
      </div>
      <div class="flex flex-column gap-2">
        <small>Organizzatore <br />
          <b
            >{{ travel.related_user.name }}
            {{ travel.related_user.last_name }}</b
          >
        </small>
      </div>
    </div>
  </footer> -->
  @if(show_organization){
  <div class="organization-info">
    @if((travel.player && !this.travel.assignment) || (travel.player &&
    this.travel.assignment && (this.travel.assignment.status.id ===
    enumAssignmentStatus.PENDING)) || (travel.player && this.travel.assignment
    && (this.travel.assignment.status.id === enumAssignmentStatus.REJECTED)) ||
    (travel.player && this.travel.assignment &&
    (this.travel.assignment.status.id === enumAssignmentStatus.REVOKED)) ){
    <div class="flex align-items-center gap-3">
      <p-avatar
        [image]="travel.player.logo | imagePipe : 'registry' : 'sm'"
        shape="circle"
      ></p-avatar>
      <div class="flex flex-column gap-2">
        <small
          >Offerto da: <br />
          <strong class="clickable" (click)="goTo()">{{
            travel.player.name
          }}</strong>
        </small>
      </div>
    </div>
    } @if(this.travel.assignment && (this.travel.assignment.status.id ===
    enumAssignmentStatus.ACCEPTED)){
    <div class="flex align-items-center gap-3">
      <p-avatar
        shape="circle"
        [image]="
          travel.assignment.target_user.profile_picture
            | imagePipe : 'user' : 'sm'
        "
      ></p-avatar>
      <div
        class="flex flex-column gap-2"
        [routerLink]="['/user/profile', travel.assignment.target_user.username]"
      >
        <small
          >Tour Leader: <br />
          <strong class="clickable"
            >{{ travel.assignment.target_user.name }}
            {{ travel.assignment.target_user.last_name }}</strong
          >
        </small>
      </div>
    </div>
    } @if(!travel.assignment) {
    <div class="flex align-items-center gap-3">
      <p-avatar
        [image]="
          travel.related_user.profile_picture | imagePipe : 'user' : 'sm'
        "
        shape="circle"
      ></p-avatar>
      <div
        class="flex flex-column gap-2"
        [routerLink]="['/user/profile', travel.related_user.username]"
      >
        <small
          >Tour Leader: <br />
          @if(travel.related_user.name){
          <strong class="clickable"
            >{{ travel.related_user.name }}
            {{ travel.related_user.last_name }}</strong
          >
          }@else {
          <strong class="clickable">{{ travel.related_user.username }}</strong>
          }
        </small>
      </div>
    </div>
    }
  </div>
  <!-- <div class="organization-info">
      @if(travel.player){
      <div class="flex align-items-center gap-3">
        <p-avatar
          [image]="travel.player.logo | imagePipe : 'registry' : 'sm'"
          shape="circle"
        ></p-avatar>
        <div class="flex flex-column gap-2">
          <small
            >Offerto da: <br />
            <strong class="clickable" (click)="goTo()">{{
              travel.player.name
            }}</strong>
          </small>
        </div>
      </div>
      }
      @if(!travel.player && !travel.assignment) {
        <div class="flex align-items-center gap-3">
          <p-avatar
          [image]="travel.related_user.profile_picture | imagePipe : 'user' : 'sm'" shape="circle"></p-avatar>
          <div class="flex flex-column gap-2" [routerLink]="['/user/profile', travel.related_user.username]">
            <small>Tour Leader: <br />
              @if(travel.related_user.name){
                <strong class="clickable">{{ travel.related_user.name }} {{ travel.related_user.last_name }}</strong>
              }@else {
                <strong class="clickable">{{ travel.related_user.username }}</strong>
              }
            </small>
          </div>
        </div>
      }
  </div> -->
  }
</a>
